import Swal from "sweetalert2";
import successIcon from "../assets/success-icon.jpg";
import errorIcon from "../assets/error-icon.jpg";
import warningIcon from "../assets/warning-icon.png";
import infoIcon from "../assets/info-icon.png";

export const showAlert = (message, type = "default", options = {}) => {
  let config = {
    iconUrl: infoIcon,
    title: "Notice",
    titleColor: "#206659",
    buttonColor: "#D0F0EC",
    buttonText: "OK"
  };

  switch (type) {
    case "success":
      config = {
        iconUrl: successIcon,
        title: "Success !",
        titleColor: "#3AC569",
        buttonColor: "#54b066",
        buttonText: "Continue"
      };
      break;
    case "error":
      config = {
        iconUrl: errorIcon,
        title: "Ooops ...",
        titleColor: "#F95F62",
        buttonColor: "#F95F62",
        buttonText: "Try Again"
      };
      break;
    case "warning":
      config = {
        iconUrl: warningIcon,
        title: "Warning !",
        titleColor: "#FFA500",
        buttonColor: "#FFE5B4",
        buttonText: "Got It"
      };
      break;
    case "info":
      config = {
        iconUrl: infoIcon,
        title: "Information",
        titleColor: "#3B82F6",
        buttonColor: "#608ecc",
        buttonText: "Understood"
      };
      break;
    default:
      break;
  }

  const showCancel = options.showCancelButton || false;
  const confirmText = options.confirmButtonText || config.buttonText;
  const cancelText = options.cancelButtonText || "Cancel";

  Swal.fire({
    showCloseButton: false,
    showConfirmButton: false,
    background: "#ffffff",
    html: `
      <div class="flex flex-col items-center text-center p-4">
        <div class="mb-4">
          <img src="${config.iconUrl}" alt="${config.title} Icon" class="w-[80px] h-[80px]" />
        </div>
        <h2 class="text-[24px] font-bold" style="color: ${config.titleColor}">${config.title}</h2>
        <p class="text-[14px] text-[#6B7280] mt-2 max-w-xs">${message}</p>
        <div class="mt-6 flex gap-2 justify-center">
          <button id="sweet-alert-confirm-btn" class="px-6 py-2 text-white rounded-full font-semibold text-[14px]"
            style="background-color: ${config.buttonColor}; color: ${type === "warning" ? "#000" : "#fff"}">
            ${confirmText}
          </button>
          ${showCancel
            ? `<button id="sweet-alert-cancel-btn" class="px-6 py-2 bg-gray-300 text-black rounded-full font-semibold text-[14px]">
                ${cancelText}
              </button>`
            : ""}
        </div>
      </div>
    `,
    customClass: {
      popup: "rounded-[20px] shadow-lg !p-0 !w-[325px]",
    },
    allowOutsideClick: false,
    allowEscapeKey: true,
    allowEnterKey: true,
  });

  // Attach event listeners
  setTimeout(() => {
    const confirmBtn = document.getElementById("sweet-alert-confirm-btn");
    const cancelBtn = document.getElementById("sweet-alert-cancel-btn");

    if (confirmBtn) {
      confirmBtn.addEventListener("click", () => {
        Swal.close();
        if (typeof options.onConfirm === "function") options.onConfirm();
      });
    }

    if (cancelBtn) {
      cancelBtn.addEventListener("click", () => {
        Swal.close();
        if (typeof options.onCancel === "function") options.onCancel();
      });
    }
  }, 100);

  // Blur background
  const interval = setInterval(() => {
    const container = document.querySelector(".swal2-container");
    if (container) {
      container.style.backdropFilter = "blur(2px)";
      container.style.webkitBackdropFilter = "blur(2px)";
      container.style.backgroundColor = "rgba(0, 0, 0, 0.3)";
      clearInterval(interval);
    }
  }, 10);
};
